import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, compose } from 'react-apollo';
import cx from 'classnames';
import s from './NewsBox.css';
import bt from '../../../components/commonStyle.css';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';

// Components
import Link from '../../Link';

// Graphql
import getImageBannerQuery from '../../../routes/home/getImageBanner.graphql';

//Images
import NewsBoxBg from '../../../../public/SiteImages/newsBoxBg.png';

class NewsBox extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      buttonLabel: PropTypes.string,
      image: PropTypes.string,
    }),
  };

  render() {
    const {  getImageBannerData } = this.props;
    let title, description, buttonLabel, image;
    if(getImageBannerData && getImageBannerData.getImageBanner) {
      title = getImageBannerData.getImageBanner.title;
      description  = getImageBannerData.getImageBanner.description;
      buttonLabel  = getImageBannerData.getImageBanner.buttonLabel;
      image = getImageBannerData.getImageBanner.image;
    }

    return (
      <div className={s.positionRelative}>
        <div className={s.bannerBg} style={{ backgroundImage: `url(${NewsBoxBg})` }} />
        <div className={s.container}>
          <Grid fluid>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className={cx(s.table)}>
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div className={s.disPlayGrid}>
                        <div>
                          <div className={s.bgImage} style={{ backgroundImage: `url(/images/banner/${image})` }} />
                        </div>
                        <div className={s.textSection}>
                          <h3 className={s.title}>{title}</h3>
                          <p className={s.caption}>{description}</p>
                          <Link to={"/whyhost"} className={cx(s.btn, bt.btnPrimary, s.linkText, bt.btnShadow)}>
                            {buttonLabel}
                          </Link>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default compose(
	withStyles(s, bt),
  graphql(getImageBannerQuery, {
    name: 'getImageBannerData',
    options: {
      ssr: true
    }
  })
)(NewsBox);


// WEBPACK FOOTER //
// src/components/Home/NewsBox/NewsBox.js